<template>

</template>

<script>
import websocketEventBus from "../eventBus/websocketEventBus";
import dataServiceRepository from "../repositories/dataService";

export default {
  name: "InitBalance",
  methods: {
    getBalance(){
      dataServiceRepository.getBalance()
          .then(resp => {
            this.$store.dispatch("addBalance", resp.data);
          })
          .catch(() => {
            this.$store.dispatch("addBalance", []);
          });
    },
    websocketUpdateBalanceObserve() {
      this.getBalance();
    }
  },
  created() {
    setTimeout(this.getBalance, 2500);
    websocketEventBus.subscribeToUpdateBalance(this.websocketUpdateBalanceObserve);
  },
  beforeDestroy() {
    websocketEventBus.unsubscribeFromUpdateBalance(this.websocketUpdateBalanceObserve);
  },
};
</script>
